export const getArticleIndex = (
    articles: InboxArticle[],
    id: number | string,
): number =>
    articles.findIndex((article) => article.id.toString() === id.toString());
